import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import { AuthGuard } from './auth/auth.guard';
import { AuthService } from './auth/auth.service';
import { LoaderService } from './interceptors/loader.service';
import { InterceptorService } from './interceptors/interceptor.service';
import { ErrorsService } from './interceptors/errors.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ImageCropperModule } from 'ngx-image-cropper';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppheaderComponent } from './components/shared/appheader/appheader.component';
import { AppmenuComponent } from './components/shared/appmenu/appmenu.component';
import { AppfooterComponent } from './components/shared/appfooter/appfooter.component';
import { LoginComponent } from './components/login/login.component';
import { ClientesComponent } from './modules/trainer-dashboard/clientes/clientes.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import {CurrencyPipe, DatePipe} from '@angular/common';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { AccesoDenegadoComponent } from './components/acceso-denegado/acceso-denegado.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NoimagePipe } from './pipes/noimage.pipe';
import { MiPerfilComponent } from './components/mi-perfil/mi-perfil.component';
import { EntrenadoresRoutingModule } from './modules/trainer-dashboard/trainer-dashboard-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    AppheaderComponent,
    AppmenuComponent,
    AppfooterComponent,
    LoginComponent,
    ClientesComponent,
    ForgotPasswordComponent,
    LoaderComponent,
    AccesoDenegadoComponent,
    NoimagePipe,
    MiPerfilComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    DragDropModule,
    NoopAnimationsModule,
    ImageCropperModule,
    EntrenadoresRoutingModule
  ],
  providers: [AuthService, LoaderService, DatePipe, CurrencyPipe,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsService, multi: true  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }